import { saleBillUpdateApi } from "../../api/saleBill/saleBillUpdateApi"

type PayloadShape = Parameters<typeof saleBillUpdateApi>[0]

export async function saleBillUpdateService(payload: PayloadShape, token: string) {
	return await saleBillUpdateApi(payload, token)
}
